import { getStore, keys, clearStore } from '@/store'
import { ROUTE } from '@/router/paths'

export function hasStudentInfo (students) {
  if (students == null) {
    return false
  }
  if (Array.isArray(students)) {
    return students.length > 0
  }
  if (typeof students === 'object') {
    if (Array.isArray(students.list)) {
      return students.list.length > 0
    }
    if (Array.isArray(students.data)) {
      return students.data.length > 0
    }
    return !!(students.student_sn || students.nickname || students.id)
  }
  return false
}

export function fetchStudents (vm) {
  return vm.$http.get('/api/learner').then((res) => {
    if (res.data.code === 200) {
      return res.data.data
    }
    return null
  })
}

export function redirectAfterLogin (vm) {
  return fetchStudents(vm).then((students) => {
    if (!hasStudentInfo(students)) {
      vm.$router.push({ path: ROUTE.ONBOARDING })
      return
    }
    vm.$router.push({ path: ROUTE.HOME })
  }).catch(() => {
    const userInfo = getStore(keys.userInfo)
    if (userInfo && userInfo.status == 0) {
      vm.$router.push({ path: ROUTE.ONBOARDING })
    } else {
      vm.$router.push({ path: ROUTE.HOME })
    }
  })
}

export function redirectIfLoggedIn (vm) {
  if (!getStore(keys.token)) {
    return Promise.resolve(false)
  }
  const currentPath = vm.$route.path
  if (currentPath === ROUTE.ONBOARDING) {
    return Promise.resolve(true)
  }
  return fetchStudents(vm).then((students) => {
    if (!hasStudentInfo(students)) {
      if (currentPath !== ROUTE.ONBOARDING) {
        vm.$router.push({ path: ROUTE.ONBOARDING })
      }
    } else if (currentPath === ROUTE.LOGIN) {
      vm.$router.push({ path: ROUTE.HOME })
    }
    return true
  }).catch(() => {
    const userInfo = getStore(keys.userInfo)
    if (userInfo && userInfo.status == 0) {
      if (currentPath !== ROUTE.ONBOARDING) {
        vm.$router.push({ path: ROUTE.ONBOARDING })
      }
    } else if (currentPath === ROUTE.LOGIN) {
      vm.$router.push({ path: ROUTE.HOME })
    }
    return true
  })
}

export function redirectIfMissingStudent (vm) {
  return redirectIfLoggedIn(vm)
}

export function logoutAndRedirect (vm) {
  return vm.$http.post('/api/member/signout').then((res) => {
    if (res.data.code == 200 && res.data.data) {
      vm.$message({
        message: res.data.data,
        type: 'success'
      })
    }
  }).catch(() => {
    // 退出接口失败时仍应清除本地登录态
  }).finally(() => {
    clearStore()
    vm.$router.replace({ path: ROUTE.LOGIN })
  })
}



// WEBPACK FOOTER //
// ./src/utils/auth.js